export class PlayerChatConfig {
	constructor(playerConfig=false) {
		this.config = {
			strip_nickname_asterisk: false,
			title: "Chat Login",
			waiting: "The webinar will begin soon. Please be patient.",
			name_title: "Your Name",
			name_type: "required",
			email_title: "Email",
			email_type: "hide",
			mobile_title: "Mobile",
			mobile_type: "hide",
			fields: [],
		}
		// if no fields in streamer->audience_js.login then we need this to stop undefined
		// at src/es6/veedoplayer/VeedoUserLogin.js line 113 'config.fields'
		if (playerConfig) {
			for (let k in playerConfig) {
				if (playerConfig.hasOwnProperty(k)) {
					this.config[k] = playerConfig[k];
				}
			}
		}
		console.log(`PlayerChatConfig::PlayerChatConfig : this.config = `, this.config);
	}
	get hasLogin() { return this.AmbiguousProperty(`login`); }
	get hasChat() { return this.AmbiguousProperty(`chat`); }
	get title() { return this.config.title; }
	get waiting() { return this.config.waiting; }
	get name_title() { return this.config.name_title; }
	get name_type() { return this.config.name_type; }
	get email_title() { return this.config.email_title; }
	get email_type() { return this.config.email_type; }
	get mobile_title() { return this.config.mobile_title; }
	get mobile_type() { return this.config.mobile_type; }
	get fields() { return this.config.fields; }

	has(prop) {
		return this.config[prop];
	}

	// AmbiguousProperty is a stupid function developed
	// to solve a bad design decision where 'noChat' and 'noLogin'
	// were being used to determine whether login or chat are supported.
	// This function, along with the noChat and noLogin values will
	// be removed, but for now we're providing this to handle legacy situations.
	// AmbiguousProperty(config, prop) will return FALSE iff:
	// 1. config is undefined
	// 1. config HAS a `noProp` property of true
	// 1. config DOES NOT have a `prop` property of false
	AmbiguousProperty(prop) {
		let config = this.config;
	    let notProp = prop.substr(0,1).toUpperCase() + prop.substr(1).toLowerCase();
	    return config  // if no config, we don't have chat
	        && !(config.hasOwnProperty(notProp) && config[notProp]) // if we have a noChat property of true => no chat
	        && (!config.hasOwnProperty(prop) || config[prop]);  // if we have a chat property of false => no chat
	}

	// mergeObjects merges two javascript objecst such that the 
	// return value will have all the values in the parameter objects, with 
	// values from the first parameter overriding the values from the second
	// parameter.
	mergeObjects(sourcea, sourceb) {
	    if (`undefined`==typeof sourcea) sourcea = {};
	    if (`undefined`==typeof sourceb) sourceb = {};
	    let r = {};    
	    // turn the order around because A trumps B
	    Object.assign(r, sourceb, sourcea);
	    for (let a in r) {
	        if (`object`==typeof(r[a])) {
	            r[a] = mergeObjects(sourcea[a], sourceb[a]);
	        }
	    }
	    return r;
	}
}

window.PlayerChatConfig = PlayerChatConfig;
console.log(`MediaServer.PlayerChatConfig : Defined window.PlayerChatConfig`);